export const PROJECT_ATTENDANCE_STAGES = [
    'project_invite',
    'project_booked',
    'project_visited',
];
/** Stage of a cycle on one project cell (ENG-T07 / prototype attendance). */
export function projectAttendanceStage(cell) {
    if (cell?.visited)
        return 'project_visited';
    if (cell?.booked)
        return 'project_booked';
    return 'project_invite';
}
/** One pass: place each row into its project stage bucket. */
export function groupRowsByProjectAttendanceStage(rows, projectCode) {
    const groups = {
        project_invite: [],
        project_booked: [],
        project_visited: [],
    };
    for (const row of rows) {
        const cell = row.cells.find((item) => item.projectCode === projectCode);
        groups[projectAttendanceStage(cell)].push(row);
    }
    return groups;
}
export function projectAttendanceStageLabel(stage, projectShortName) {
    if (stage === 'project_visited')
        return `Посетил ${projectShortName}`;
    if (stage === 'project_booked')
        return 'Записан на БТ';
    return `Пригласить на ${projectShortName}`;
}
export function parseAttendanceMode(raw) {
    if (raw === 'funnel' || raw === 'board' || raw === 'matrix')
        return raw;
    return 'matrix';
}
export function parseAttendanceStage(raw) {
    if (raw === 'project_invite' ||
        raw === 'project_booked' ||
        raw === 'project_visited') {
        return raw;
    }
    return 'all';
}
export function visitKindLabel(kind) {
    if (kind === 'bt')
        return 'БТ';
    if (kind === 'event')
        return 'Мер.';
    return 'Клиент';
}
export function pluralEngagements(n) {
    const mod10 = n % 10;
    const mod100 = n % 100;
    if (mod10 === 1 && mod100 !== 11)
        return 'Вовлечение';
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
        return 'Вовлечения';
    }
    return 'Вовлечений';
}
